import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import flattenDeep from 'lodash/flattenDeep';
import React, { useState, useRef, useMemo } from 'react';
import { encodeSelections } from '@/utils/widget/parseSelections';
import Button from '@/components/Button';
import { Label, Input } from '@/components/FormElements';
import { TemplateRevealPill } from '@/components/Editor/Form/fields/Template';
import ChartLabels from '@/components/Editor/Form/fields/ChartLabels';
import { getSelectionGroupItemByIndex } from '../utils';
import { selectionConfig } from '@/components/widget/visualizations/Receipt';
import useSelections from '@/components/widget/misc/useSelections';
import useSubscribeWidgetResults from '@/components/widget/visualizations/hooks/useSubscribeWidgetResults';
import generalConfig from '@/config/general';
import userUploads from '@/config/userUploads';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import formElementStyles from '@/components/FormElements/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const ACCEPTED_MEME_TYPES = userUploads.acceptedImgMemeTypes;
const ACCEPTED_FILE_EXTS = userUploads.acceptedImgFileExtensions.map(ext => `.${ext}`).join(',');
const MAX_UPLOAD_SIZE = 50000; // bytes

const EditFormRecieptFields = _ref => {
  var _config$globalSeriesO;

  let {
    nameSpace,
    sectionId,
    reportingWidgetId,
    config,
    onChange,
    onUpload,
    onEditSelections
  } = _ref;
  const fileInputElement = useRef(null);
  const ctaInputId = `receipt-cta-${sectionId}`;
  const ctaDestinationId = `receipt-cta-destination-${sectionId}`;
  const ctaPromptId = `receipt-cta-prompt-${sectionId}`;
  const ctaPromptImgId = `receipt-cta-prompt-img-${sectionId}`;
  const templateFieldId = `receipt-template-${sectionId}`;
  const {
    0: uploadError,
    1: setUploadError
  } = useState('');
  const {
    selections = '',
    labelsSelections = '',
    selectionsLabeled = false
  } = config; // Get current selection results

  const results = useSubscribeWidgetResults(reportingWidgetId); // Get relevant results for each selection group

  const {
    selectionResults
  } = useSelections({
    results,
    selections,
    selectionConfig,
    selectionsLabeled
  });
  const exampleValue = useMemo(() => {
    const exampleSelection = getSelectionGroupItemByIndex(flattenDeep(selectionResults), 0);
    return typeof exampleSelection.value !== 'undefined' ? exampleSelection.value : 10;
  }, [selectionResults]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [onEditSelections ? /*#__PURE__*/_jsx(ChartLabels, {
      nameSpace: nameSpace,
      selections: labelsSelections ? encodeSelections(labelsSelections || []) : undefined,
      defaultSelections: config.defaultLabelsSelections,
      onChange: onChange,
      onEditSelections: () => onEditSelections('labels')
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(TemplateRevealPill, {
      id: templateFieldId,
      label: "General Format",
      caption: "Default formatting. Can be overwritten by other formatting settings.",
      exampleValue: exampleValue,
      template: (_config$globalSeriesO = config.globalSeriesOptions) === null || _config$globalSeriesO === void 0 ? void 0 : _config$globalSeriesO.template,
      onChange: value => onChange('globalSeriesOptions', {
        template: value
      })
    }), /*#__PURE__*/_jsx(Label, {
      forInput: ctaInputId,
      className: parentStyles.formField,
      text: "Submit Button (Text & Color)",
      children: /*#__PURE__*/_jsxs("div", {
        className: parentStyles.formField__row,
        children: [/*#__PURE__*/_jsx(Input, {
          id: ctaInputId,
          placeholder: "Call to action",
          defaultValue: config.ctaButton,
          onChange: evt => onChange('', {
            ctaButton: evt.target.value
          })
        }), /*#__PURE__*/_jsx(Input, {
          type: "color",
          className: parentStyles.formField__row__colorPicker,
          defaultValue: config.ctaButtonColor || generalConfig.colors.bluePrimary,
          onChange: evt => onChange('', {
            ctaButtonColor: evt.target.value
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Label, {
      forInput: ctaDestinationId,
      text: "Submit Destination",
      className: parentStyles.formField,
      caption: "Link to direct user when they click on this button. May be a URL or an on-page #element identifier.",
      children: /*#__PURE__*/_jsx(Input, {
        id: ctaDestinationId,
        placeholder: "https://example/page",
        defaultValue: config.ctaDestination,
        onChange: evt => onChange('', {
          ctaDestination: evt.target.value
        })
      })
    }), /*#__PURE__*/_jsx(Label, {
      forInput: ctaPromptId,
      text: "Prompt To Action",
      className: parentStyles.formField,
      caption: "Text to urge the user to click on the submit button.",
      children: /*#__PURE__*/_jsx(Input, {
        id: ctaPromptId,
        placeholder: "Prompt user to act",
        defaultValue: config.ctaPrompt,
        onChange: evt => onChange('', {
          ctaPrompt: evt.target.value
        })
      })
    }), /*#__PURE__*/_jsxs(Label, {
      forInput: ctaPromptImgId,
      text: "Prompt Image",
      className: clsx(parentStyles.formField, parentStyles['formField--pill'], uploadError ? '-mb-none' : ''),
      caption: "Small square image to accompany the the prompt text (max 50kb).",
      children: [/*#__PURE__*/_jsx("input", {
        id: ctaPromptImgId,
        ref: fileInputElement,
        type: "file",
        accept: ACCEPTED_FILE_EXTS,
        onChange: evt => {
          const {
            files
          } = evt.target;
          const firstFile = (files || [])[0];
          if (!firstFile) return;

          if (!ACCEPTED_MEME_TYPES.includes(firstFile.type)) {
            return setUploadError('Unaccepted file type');
          }

          if (firstFile.size > MAX_UPLOAD_SIZE) {
            return setUploadError('File larger than 50kb max');
          }

          setUploadError(''); // reset

          onUpload('', {
            ctaPromptImgSrc: '{{downloadUrl}}'
          }, firstFile);
        }
      }), config.ctaPromptImgSrc ? /*#__PURE__*/_jsx(Button, {
        className: parentStyles.formField__sideButton,
        variant: "text",
        type: "button",
        onClick: evt => {
          evt.stopPropagation();
          evt.preventDefault();
          onChange('', {
            ctaPromptImgSrc: ''
          }); // Remove any input file references

          if (fileInputElement.current) {
            fileInputElement.current.value = '';
          }
        },
        leftIcon: /*#__PURE__*/_jsx(CloseIcon, {})
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), uploadError && /*#__PURE__*/_jsx("p", {
      className: clsx(formElementStyles.errorMessage, '-mb'),
      children: uploadError
    })]
  });
};

export default EditFormRecieptFields;